import {useCallback} from 'react'
// Hooks
import {useRouteParams} from './use-route-params'
// Helpers
import {ensureLeadingSlash, ensureTrailingSlash} from '../utils/string-helpers'

export const useBoundRoute = (): (
  path: string,
  organizationSlugOverride?: string | null,
  ballotSlugOverride?: string | null,
) => string | undefined | null => {
  const {isReady, organizationSlug, ballotSlug} = useRouteParams()

  return useCallback((
    path: string,
    organizationSlugOverride: string | null = null,
    ballotSlugOverride: string | null = null,
  ) => {
    let cleanPath = path
    if (cleanPath?.startsWith('/')) cleanPath = cleanPath.slice(1)
    if (cleanPath?.endsWith('/')) cleanPath = cleanPath.slice(0, -1)
    if (
      (
        !organizationSlug
          && !organizationSlugOverride
      ) || (
        !ballotSlug
        && !ballotSlugOverride
      )
    ) {
      const resolvedHref = ensureTrailingSlash(ensureLeadingSlash(cleanPath || '/'))
      return resolvedHref
    }
    let resolvedHref = (
      cleanPath === ''
        ? `/o/${organizationSlugOverride || organizationSlug}/${ballotSlugOverride || ballotSlug}`
        : `/o/${organizationSlugOverride || organizationSlug}/${ballotSlugOverride || ballotSlug}/${cleanPath}`
    )

    const hasQueryParams = cleanPath.includes('?')
    return hasQueryParams ? resolvedHref : ensureTrailingSlash(resolvedHref)
  }, [
    isReady,
    organizationSlug,
    ballotSlug,
  ])
}
